// //////////Account.jsx
// Updated to use Ant Design Dropdown with hover trigger

import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../functions/api';
import { Dropdown, Button, Tooltip, Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PreferencesModal from './PreferencesModal.jsx';
import User from './Users.jsx';
import useLocalStorage from '../functions/useLocalStorage';
import getUserId from '../functions/getUserId';
import CategoryPreferencesModal from './CategoryPreferencesModal.jsx';
import MaintenanceModal from './MaintenanceModal.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { logIn, logOut, clearUserData, clearPortfolioData,setWidgetPreferences } from '../redux/actions';
import store from '../redux/store';
import { getPortfolioData, getFavoritesData } from '../redux/reducers/portfolioReducer';
import { getAlertRelatedTrendsearchData } from '../redux/reducers/trendsearchReducer';
import { getDataParameters, setFilteredTickers,setFilteredTickersF, getPortfolioESGData, getFavoritesESGData } from '../redux/reducers/portfolioReducer';
import BrokerAccessModal from './BrokerAccessModal.jsx';
import { getStoreSize } from '../functions/storeSize';
import fetchWidgetprefs from '../functions/fetch_storeWidgetprefs';
import ESGChecker from './ESGChecker.jsx';
import MarketAlerts from './MarketAlerts.jsx';
import ClauseManagement from './ClauseManagement.jsx';
import AlertScopesManagement from './AlertScopesManagement.jsx';
import AlertEffectiveness from './AlertEffectiveness.jsx';
import ScriptReporting from './ScriptReporting.jsx';
import ReleaseNotesModal from './ReleaseNotesModal.jsx'; // DAS-2992
import AlphaRegisterModal from './AlphaRegisterModal.jsx'; // DAS-3157
import AdvicePipelineModal from './AdvicePipelineModal.jsx'; // DAS-3237
import TickerMaintenance from './TickerMaintenance.jsx';
import Portfolio_Datamanagement from './Portfolio_Datamanagement.jsx';
import Investment_Strategy from './Investment_Strategy.jsx';
import PlanSettingsPanel from './PlanSettingsPanel.jsx'; // DAS-3026: the numbers the advice reads, under the document
import Prime_Objective from './Prime_Objective.jsx';
import TrendsearchManagement from './TrendsearchManagement.jsx';
import ReduxViewModal from './ReduxViewModal.jsx';
import DatabaseSchemaSearch from './DatabaseSchemaSearch.jsx';
import DeGiroSpikeModal from './DeGiroSpikeModal.jsx'; // DAS-2573
import LLMModelsModal from './LLMModelsModal.jsx';
import SecurityAuditModal from './SecurityAuditModal.jsx';
import AgenticOverviewModal from './AgenticOverviewModal.jsx'; // DAS-3094
import buildAccountMenuItems from '../functions/accountMenuItems';
import { Settings as Icon } from "lucide-react";
import NavButton from "./ui/NavButton";
import Box from "@mui/material/Box";


const Account = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [token, setToken] = useLocalStorage('token', null);
  const [isMaintenanceModalVisible, setIsMaintenanceModalVisible] = useState(false);
  // DAS-2557: Read userId from Redux (set atomically with isLoggedIn by the LOGIN action)
  // instead of a separate local async state. The local copy lagged behind isLoggedIn on
  // login, so the menu rendered only the non-admin half of the options until a refresh.
  const userId = useSelector((state) => state.auth.userId);
  const dataParameters = useSelector((state) => state.portfolio.dataParameters);
  const [isDatabaseModalVisible, setIsDatabaseModalVisible] = useState(false); // New state for the modal visibility
  const [isTickerMaintenanceModalVisible, setIsTickerMaintenanceModalVisible] = useState(false); // New state for the modal visibility
  const dispatch = useDispatch();
  const { userName } = useSelector(state => state.auth);
  const isDebugMode = useSelector(state => state.debugMode?.isDebugMode);
  const [isPortfolioDataManagementVisible, setIsPortfolioDataManagementVisible] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);



  useEffect(() => {
    if (isDebugMode) {
      // Use store.getState() to access the full state when debug mode is on
      const allState = store.getState();  // Assuming 'store' is imported or accessible in this file
      console.log("All State: ", allState);
      // console.log("isDebugMode: ", isDebugMode);
    }
  }, [isDebugMode]);  // Effect runs only when isDebugMode changes


  const [isAlertEffectivenessModalVisible, setIsAlertEffectivenessModalVisible] = useState(false);
  const [isScriptReportingModalVisible, setIsScriptReportingModalVisible] = useState(false);
  const [isReleaseNotesVisible, setIsReleaseNotesVisible] = useState(false); // DAS-2992
  const [isAlphaRegisterVisible, setIsAlphaRegisterVisible] = useState(false); // DAS-3157
  const [isAdvicePipelineVisible, setIsAdvicePipelineVisible] = useState(false); // DAS-3237
  const [isInvestmentStrategyModalVisible, setIsInvestmentStrategyModalVisible] = useState(false);
  const [isPrimeObjectiveModalVisible, setIsPrimeObjectiveModalVisible] = useState(false); // DAS-2568
  const [isTrendsearchModalVisible, setIsTrendsearchModalVisible] = useState(false);
  const [isReduxViewModalVisible, setIsReduxViewModalVisible] = useState(false);
  const [isDatabaseSchemaSearchVisible, setIsDatabaseSchemaSearchVisible] = useState(false);
  const [isDeGiroSpikeVisible, setIsDeGiroSpikeVisible] = useState(false); // DAS-2573
  const [isLLMModelsVisible, setIsLLMModelsVisible] = useState(false);
  const [isSecurityAuditVisible, setIsSecurityAuditVisible] = useState(false);
  const [isAgenticOverviewVisible, setIsAgenticOverviewVisible] = useState(false); // DAS-3094

    const handleAEClick = () => {
      setIsAlertEffectivenessModalVisible(true);
    };

    const handleSRClick = () => {
      setIsScriptReportingModalVisible(true);
    };

    const handleInvestmentStrategyClick = () => {
      setIsInvestmentStrategyModalVisible(true);
    };
    const handleTrendsearchClick = () => {
      setIsTrendsearchModalVisible(true);
    };

    const handleTickerMaintenancelick = () => {
      setIsTickerMaintenanceModalVisible(true);
    };

    const handleAlertEffectivenessModalClose = () => {
      setIsAlertEffectivenessModalVisible(false);
    };

    const handleScriptReportingModalClose = () => {
      setIsScriptReportingModalVisible(false);
    };


  const prevFilteredTickersRef = useRef();
  const prevFilteredTickersFRef = useRef();

  const stored_portfolioData = useSelector((state) => state.portfolio.data);
  // console.log("stored_portfolioData: ", stored_portfolioData);
  const stored_favoritesData = useSelector((state) => state.favorites?.data);

  const allTickers = stored_portfolioData?.portfolio?.map(item => item.Ticker) || [];

  const allTickersF = stored_favoritesData?.data?.map(item => item.Ticker) || [];

  const filteredTickers = allTickers.filter(ticker => ticker !== null && ticker !== '');
  const filteredTickersF = allTickersF.filter(ticker => ticker !== null && ticker !== '');

  const [isESGCheckerVisible, setIsESGCheckerVisible] = useState(false);
const [isClauseModalVisible, setIsClauseModalVisible] = useState(false);
const [isAlertScopesVisible, setIsAlertScopesVisible] = useState(false);

const handleClausesClick = () => {
  setIsClauseModalVisible(true);
};

const handleClauseModalClose = () => {
  setIsClauseModalVisible(false);
};

const handleAlertScopesClick = () => {
  setIsAlertScopesVisible(true);
};

const handleAlertScopesClose = () => {
  setIsAlertScopesVisible(false);
};

  
  const handleESGCheckerClick = () => {
    window.open('/esgcheck', '_blank');
  };
  
  

  useEffect(() => {
    const storeSize = getStoreSize();
    // console.log("Redux Store Size in bytes:", storeSize);
  }, []);

  useEffect(() => {
    if (JSON.stringify(prevFilteredTickersRef.current) !== JSON.stringify(filteredTickers)) {
      // console.log("ACCOUNT: Dispatching filteredTickers: ", filteredTickers);
      dispatch(setFilteredTickers(filteredTickers));
    }
    prevFilteredTickersRef.current = filteredTickers;
  }, [filteredTickers, dispatch]);
  
  useEffect(() => {
    if (JSON.stringify(prevFilteredTickersFRef.current) !== JSON.stringify(filteredTickersF)) {
      // console.log("ACCOUNT: Dispatching filteredTickersF: ", filteredTickersF);
      dispatch(setFilteredTickersF(filteredTickersF));
    }
    prevFilteredTickersFRef.current = filteredTickersF;
  }, [filteredTickersF, dispatch]);


  useEffect(() => {
    // console.log("check on dataparameters")
    if (!dataParameters) {
      dispatch(getDataParameters());
      // console.log("ACCOUNT.JSX: get DP dispatch")
    }
  }, [dataParameters, dispatch, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
    // console.log("isLoggedIn: ", isLoggedIn);
    dispatch(getPortfolioData(token));
    dispatch(getFavoritesData(token));
    // DAS-1360: Preload TrendSearch aggregates for alert-related tickers
    dispatch(getAlertRelatedTrendsearchData(token));
    // dispatch(getDataParameters());

    }
  }, [isLoggedIn, token, dispatch]);
  // }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn && stored_portfolioData) {
    // console.log("isLoggedIn: ", isLoggedIn);
    dispatch(getPortfolioESGData(filteredTickers));
    }
  }, [isLoggedIn, stored_portfolioData]);

  useEffect(() => {
    if (isLoggedIn && stored_favoritesData) {
      // console.log("filteredTickersF: ", filteredTickersF)
    // console.log("isLoggedIn: ", isLoggedIn);
    dispatch(getFavoritesESGData(filteredTickersF));
    }
  }, [isLoggedIn, stored_favoritesData]);

  useEffect(() => {
    if (isLoggedIn && userId && token) {
      // Fetch and set widget preferences
      // console.log("fetching widget prefs");
      const fetchAndUpdateWidgetPrefs = async () => {
        try {
          const widgetPrefs = await fetchWidgetprefs(userId, token);

// Ensure data is properly extracted
if (widgetPrefs) {
    dispatch(setWidgetPreferences(widgetPrefs.widgetPreferences, widgetPrefs.widgetPreload));
}

        } catch (error) {
          console.error('Error fetching widget preferences:', error);
        }
      };
      fetchAndUpdateWidgetPrefs();
    }
  }, [isLoggedIn, userId, token, dispatch]); 


  const [isPreferencesModalVisible, setIsPreferencesModalVisible] = useState(false);
  const [modalState, setModalState] = useState({
    isLoginRegisterModalVisible: false,
    defaultTab: "2"
  });

  const [isCategoryPreferencesModalVisible, setIsCategoryPreferencesModalVisible] = useState(false);
  const [categoryPreferences, setCategoryPreferences] = useState([]);
  const [formattedName, setFormattedName] = useState(null);
  const [isBrokeraccessmodalVisible, setIsBrokeraccessmodalVisible] = useState(false);
  const handleBrokeraccessModalClose = () => {
    setIsBrokeraccessmodalVisible(false);};
 
  useEffect(() => {
  const fetchUserDetails = async () => {
    const storedToken = localStorage.getItem('token');
    setToken(storedToken);

    if (!storedToken) {
      dispatch(logOut());
      setLoadingUser(false);
      return;
    }

    try {
      const response = await api.get('/user_check');
      const { ID, first_name, last_name } = response.data;
      const formattedName = `${first_name} ${last_name}`;
      // DAS-2557: redux LOGIN action sets userId; no separate local userId state to update.
      setFormattedName(formattedName);
      dispatch(logIn({ ID, userName: formattedName }));
    } catch (error) {
      console.error('Error fetching user details:', error);
      localStorage.removeItem('token');
      dispatch(logOut());
    } finally {
      setLoadingUser(false);
    }
  };

  fetchUserDetails();
}, [token]);


  const handleLogout = () => {
    dispatch(clearUserData()); // Dispatch logOut action to Redux
    dispatch(clearPortfolioData());
    dispatch({ type: 'CLEAR_USER_DATA' })
    dispatch({ type: 'CLEAR_PORTFOLIO_DATA' })
    dispatch({ type: 'CLEAR_FAVORITES_DATA' })
    localStorage.removeItem('token');
    setToken(null); // clear the token state
    // setUserLoggedIn(prev => !prev);  // Toggle to trigger re-render
  
    dispatch(logOut());

    //// console.log("clearUserData dispatched");
    // console.log('Redux State:', store.getState());


    setModalState({ ...modalState, isLoginRegisterModalVisible: false });
  };

  const handleCategoryPreferencesClick = () => {
    setIsCategoryPreferencesModalVisible(true);
};


const handleBrokeraccessClick = () => {
  setIsBrokeraccessmodalVisible(true);
};

  const handlePreferencesClick = () => {
    setIsPreferencesModalVisible(true);
  };

  const handlePreferencesModalClose = () => {
    setIsPreferencesModalVisible(false);
  };

  const handleLoginClick = () => {
    setModalState({
      isLoginRegisterModalVisible: true,
      defaultTab: "2"
    });
  };

  const handleRegisterClick = () => {
    setModalState({
      isLoginRegisterModalVisible: true,
      defaultTab: "1"
    });
  };

  const handleMaintenanceClick = () => {
    setIsMaintenanceModalVisible(true); // Set the modal visibility to true
  };
  
  // Add handler to open the Database modal
  const handleDatabaseClick = () => {
    setIsDatabaseModalVisible(true);  // This will open the Database modal
  };

  const handleDatabaseModalClose = () => {
    setIsDatabaseModalVisible(false);  // This will close the Database modal
  };

  // DAS-2597: removed the eager schema prefetch that ran on every login and
  // discarded its result — it reflected the whole `dashboard` schema (~218
  // tables) and was the single biggest contributor to slow login. The clause/
  // alert features that need the schema fetch it lazily (gated by `isVisible`,
  // sharing the module-level schemaCache); the backend now caches the reflection
  // (DR_dashboard_structure), so that first lazy fetch is fast too.

  const guestClickNotified = useRef(false);
  const handleGuestClick = useCallback(() => {
    if (!isLoggedIn && !guestClickNotified.current) {
      guestClickNotified.current = true;
      api.post('/visitor_about_click', {
        source: 'guest_button',
        user_id: null,
        language: navigator.language || 'unknown',
        screen: `${window.screen.width}x${window.screen.height}`,
        referrer: document.referrer || '',
        page_url: window.location.href,
      }).catch(() => {});
    }
  }, [isLoggedIn]);

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'login':
        handleLoginClick();
        break;
      case 'register':
        handleRegisterClick();
        break;
      case 'category_preferences':
        handleCategoryPreferencesClick();
        break;
      case 'data_preferences':
        handlePreferencesClick();
        break;
      case 'broker_access':
        handleBrokeraccessClick();
        break;
      case 'logout':
        handleLogout();
        break;
      case 'maintenance':
        handleMaintenanceClick();
        break;
      case 'market_alerts':
        handleDatabaseClick();
        break;
      case 'clauses':
        handleClausesClick();
        break;
      case 'alert_scopes':
        handleAlertScopesClick();
        break;
      case 'alert_effectiveness':
        handleAEClick();
        break;
      case 'portfolio_data_management':
        setIsPortfolioDataManagementVisible(true);
        break;
      case 'script_reporting':
        handleSRClick();
        break;
      case 'release_notes': // DAS-2992
        setIsReleaseNotesVisible(true);
        break;
      case 'alpha': // DAS-3157
        setIsAlphaRegisterVisible(true);
        break;
      case 'advice_pipeline': // DAS-3237
        setIsAdvicePipelineVisible(true);
        break;
      case 'trendsearch_management':
        handleTrendsearchClick();
        break;
      case 'backtesting':
        // DAS-1788: Backtesting now works on PROD (removed dev-only restriction)
        window.open('/backtesting', '_blank');
        break;
      case 'ticker_maintenance':
        handleTickerMaintenancelick();
        break;
      case 'esg_checker':
        handleESGCheckerClick();
        break;
      case 'investment_strategy':
        handleInvestmentStrategyClick();
        break;
      case 'prime_objective': // DAS-2568
        setIsPrimeObjectiveModalVisible(true);
        break;
      case 'ai_ideas':
        // DAS-1389: Open AI Ideas page in new tab (dev only)
        if (process.env.NODE_ENV === 'development') {
          window.open('/ai-ideas', '_blank');
        }
        break;
      case 'redux_view':
        // DAS-1421: Open Redux state viewer modal
        setIsReduxViewModalVisible(true);
        break;
      case 'database_schema_search':
        // DAS-1473: Open database schema search modal
        setIsDatabaseSchemaSearchVisible(true);
        break;
      case 'degiro_spike':
        // DAS-2573: Open the DeGiro derivatives/realtime spike page
        setIsDeGiroSpikeVisible(true);
        break;
      case 'llm_models':
        setIsLLMModelsVisible(true);
        break;
      case 'security_audit':
        setIsSecurityAuditVisible(true);
        break;
      case 'agentic_overview':
        setIsAgenticOverviewVisible(true);
        break;
      case 'drift_watch':
        // DEV-only: open the agent instruction-drift demo page in a new tab
        if (process.env.NODE_ENV === 'development') {
          window.open('/drift-watch', '_blank');
        }
        break;
      case 'alert_discovery':
        window.open('/alert_discovery', '_blank');
        break;
      default:
        break;
    }
  };

  // Expose a global opener so other components (Homepage shortcuts) can trigger the same actions
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    window.openAccountMenu = (key) => handleMenuClick({ key });
  }

  // DAS-1551: Always render button - show immediately when token exists or when not logged in
  // Don't block rendering waiting for userId to load, as it's set asynchronously
  // The button will show with appropriate menu items based on current state
  if (loadingUser && !token) {
    // Only return null if we're still loading and have no token (initial load)
    return null;
  }

  // DAS-2557: menu items are a pure function of (isLoggedIn, userId). Both come
  // from Redux now, so the admin half can never lag behind the logged-in state.
  const items = buildAccountMenuItems({ isLoggedIn, userId });

  return (
    <div>
      <Dropdown
        menu={{
          items: items,
          onClick: handleMenuClick
        }}
        placement="bottomLeft"
        // DAS-2878: hover-only trigger made this menu unreachable by click,
        // tap (touch/mobile) or keyboard focus, and unreachable by any
        // click-only automation (incl. the DR_testing_ticket_auditor `verify:
        // ui` grammar, which cannot express hover-before-click). Adding
        // 'click' is additive — hover still opens it exactly as before.
        trigger={['hover', 'click']}
        // DAS-2992 repair: default mouseLeaveDelay (0.1s) is tight enough that a
        // click landing on a menu item right after the trigger opens the dropdown
        // can race the hover-close timer and lose the item click before it
        // registers (seen live on the auditor's headless click-through: identical
        // trigger->item click chain passed some runs and failed others). A longer
        // leave delay gives that transition more slack without affecting open.
        mouseLeaveDelay={0.3}
        onOpenChange={(open) => { if (open) handleGuestClick(); }}
      >
        <span data-testid="account-menu-trigger">
          <NavButton
            icon={<Icon size={14} />}
            label={userName || "Guest"}
            tooltip={
              isLoggedIn
                ? "Manage your data preferences"
                : "Login, or Register to Login. Then, this place also enables you to manage your datapreferences"
            }
          />
        </span>
      </Dropdown>


 
      <MarketAlerts isVisible={isDatabaseModalVisible} onClose={handleDatabaseModalClose} />

      {isPreferencesModalVisible && (
        <PreferencesModal
          userId={getUserId()}
          onClose={handlePreferencesModalClose}
        />
      )}

      {isClauseModalVisible && (
        <ClauseManagement
          isVisible={isClauseModalVisible}
          onClose={handleClauseModalClose}
        />
      )}

      {isAlertScopesVisible && (
        <AlertScopesManagement
          isVisible={isAlertScopesVisible}
          onClose={handleAlertScopesClose}
        />
      )}

      <AlertEffectiveness 
        isVisible={isAlertEffectivenessModalVisible} 
         onClose={handleAlertEffectivenessModalClose} 
       />

      <ScriptReporting 
        isVisible={isScriptReportingModalVisible} 
         onClose={handleScriptReportingModalClose} 
       /> 

      <ReleaseNotesModal
        isVisible={isReleaseNotesVisible}
        onClose={() => setIsReleaseNotesVisible(false)}
      />
      <AlphaRegisterModal
        isVisible={isAlphaRegisterVisible}
        onClose={() => setIsAlphaRegisterVisible(false)}
      />
      <AdvicePipelineModal
        isVisible={isAdvicePipelineVisible}
        onClose={() => setIsAdvicePipelineVisible(false)}
      />


      <User
        defaultTab={modalState.defaultTab}
        setToken={setToken}
        visible={modalState.isLoginRegisterModalVisible}
        setVisible={(isVisible) => setModalState({...modalState, isLoginRegisterModalVisible: isVisible})}
      />

      <CategoryPreferencesModal 
      isVisible={isCategoryPreferencesModalVisible} 
      setIsVisible={setIsCategoryPreferencesModalVisible}
      categoryPreferences={categoryPreferences}
      />

      <MaintenanceModal 
          isVisible={isMaintenanceModalVisible} 
          setIsVisible={setIsMaintenanceModalVisible} 
        />

      <BrokerAccessModal 
          isVisible={isBrokeraccessmodalVisible} 
          setIsVisible={setIsBrokeraccessmodalVisible} 
          onClose={handleBrokeraccessModalClose}
        />      

      {isTickerMaintenanceModalVisible && (
        <TickerMaintenance
          isVisible={isTickerMaintenanceModalVisible}
          setIsVisible={setIsTickerMaintenanceModalVisible}
        />
      )}

        {isPortfolioDataManagementVisible && (
      <Modal
      open={isPortfolioDataManagementVisible}
      onCancel={() => setIsPortfolioDataManagementVisible(false)}
      footer={null}
      width="90%"
      title="Portfolio Data Management"
    >
      <Portfolio_Datamanagement />
    </Modal>
    )}

    {isInvestmentStrategyModalVisible && (
      <Modal
        open={isInvestmentStrategyModalVisible}
        onCancel={() => setIsInvestmentStrategyModalVisible(false)}
        footer={null}
        width="90%"
        title="Investment Strategy"
      >
        <Investment_Strategy />
        <PlanSettingsPanel />
      </Modal>
    )}

    {/* DAS-2568: Prime Objective Modal */}
    {isPrimeObjectiveModalVisible && (
      <Modal
        open={isPrimeObjectiveModalVisible}
        onCancel={() => setIsPrimeObjectiveModalVisible(false)}
        footer={null}
        width="70%"
        title="Prime Objective"
      >
        <Prime_Objective />
      </Modal>
    )}

    {isTrendsearchModalVisible && (
      <Modal
        open={isTrendsearchModalVisible}
        onCancel={() => setIsTrendsearchModalVisible(false)}
        footer={null}
        width="95%"
        title="TrendSearch Management"
      >
        <TrendsearchManagement />
      </Modal>
    )}

    {/* DAS-1421: Redux State Viewer Modal */}
    <ReduxViewModal
      isVisible={isReduxViewModalVisible}
      onClose={() => setIsReduxViewModalVisible(false)}
    />

    {/* DAS-1473: Database Schema Search Modal */}
    <DatabaseSchemaSearch
      isVisible={isDatabaseSchemaSearchVisible}
      onClose={() => setIsDatabaseSchemaSearchVisible(false)}
    />

    {/* DAS-2573: DeGiro spike (derivatives + near-realtime quote) */}
    <DeGiroSpikeModal
      isVisible={isDeGiroSpikeVisible}
      onClose={() => setIsDeGiroSpikeVisible(false)}
      userId={userId}
    />

    {/* DAS-2110: LLM Models Modal */}
    <LLMModelsModal
      isVisible={isLLMModelsVisible}
      onClose={() => setIsLLMModelsVisible(false)}
    />

    {/* DAS-2207: Security Audit Modal (dev only) */}
    {isAgenticOverviewVisible && (
      <AgenticOverviewModal
        isVisible={isAgenticOverviewVisible}
        onClose={() => setIsAgenticOverviewVisible(false)}
      />
    )}
    {isSecurityAuditVisible && (
      <SecurityAuditModal
        isVisible={isSecurityAuditVisible}
        onClose={() => setIsSecurityAuditVisible(false)}
      />
    )}

    </div>
  );
};

export default Account;

